import { useGetResourceFieldTypesSuspense } from "@/orval/gen"
import { ResourceTypeCategory } from "../../../../@client/Theasoft_DataClasses_Dispo"

export default function useGetResourceFieldTypes(
  category: ResourceTypeCategory
) {
  return useGetResourceFieldTypesSuspense({
    fieldVisibility: "Resource",
    category,
  })
}
